









import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import CommentsResponse from '@/components/comment/comments-response.vue';

@Component({
  components: {
    CommentsResponse,
    PageTitle
  }
})
export default class CommentsResponsePage extends Vue {
}
